/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
import {
	alpha,
	Card,
	CardActionArea,
	CardActionAreaProps,
	CardProps,
	useTheme
} from '@mui/material';

import React, { forwardRef } from 'react';
import { TOnClick } from 'types/props';

interface ISelectableCardProps extends Omit<CardProps, 'onClick'> {
	selected?: boolean;
	disabled?: boolean;
	actionsAreaProps?: Omit<CardActionAreaProps, 'onClick' | 'disabled'>;
	onClick?: TOnClick;
	'data-testid'?: string;
}

const SelectableCard = forwardRef<HTMLDivElement, ISelectableCardProps>(
	(
		{
			selected = false,
			children = null,
			disabled = false,
			onClick = undefined,
			sx,
			actionsAreaProps = {},
			'data-testid': dataTestId = undefined,
			...rest
		},
		ref
	) => {
		const {
			spacing,
			palette: {
				primary: { main: primaryMainColor }
			}
		} = useTheme();

		return (
			<Card
				ref={ref}
				data-testattr={`selected:${selected}`}
				data-testid={dataTestId}
				variant="outlined"
				{...rest}
				sx={{
					...(disabled
						? {}
						: {
								':hover': {
									boxShadow: `0 0 ${spacing(1.5)} 0 ${alpha(primaryMainColor, 0.2)}`
								},
								':active': {
									borderColor: primaryMainColor
								}
							}),

					borderRadius: 2,
					transition: 'border-color 150ms ease, box-shadow 200ms ease',
					borderColor: selected ? 'primary.main' : 'grey.300',
					...sx
				}}
			>
				<CardActionArea
					component="div"
					disableRipple
					data-testid="card-action-area"
					{...actionsAreaProps}
					sx={{
						...(actionsAreaProps.sx || {}),
						height: '100%'
					}}
					onClick={onClick}
					disabled={disabled}
				>
					{children}
				</CardActionArea>
			</Card>
		);
	}
);

export default SelectableCard;
